import { Route, Routes } from "react-router-dom";
import EquipmentAlertViewMonitoring from "pages/monitoring/equipment-alert-view";
import EquipmentAlertHistoryTrackingMonitoring from "pages/monitoring/equipment-alert-history-tracking";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringEquipmentAlertHistoryTrackingRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <EquipmentAlertHistoryTrackingMonitoring />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <EquipmentAlertViewMonitoring />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}